import { useQuery } from 'react-query'
import { UseYotpo } from './types'

const YOTPO_TOKEN_URL = process.env.REACT_APP_YOTPO_TOKEN_URL
const YOTPO_KEY = process.env.REACT_APP_YOTPO_KEY
const YOTPO_CLIENT_SECRET = process.env.REACT_APP_YOTPO_CLIENT_SECRET

const options = {
  method: 'GET',
  headers: { 'Content-Type': 'application/json' }
}

export const useYotpo = (productId: string): UseYotpo => {
  const getAccessTokenBody = {
    grant_type: 'client_credentials',
    client_id: YOTPO_KEY ?? '',
    client_secret: YOTPO_CLIENT_SECRET ?? ''
  }

  const getIsError = (responseData: any) => {
    if (responseData.error) {
      return responseData.error
    }

    if (responseData.status?.code >= 400) {
      return responseData.status?.message
    }
  }

  const token = useQuery(
    ['useYotpoToken'], async () => {
      const response = await fetch(YOTPO_TOKEN_URL ?? '', {
        method: 'POST',
        headers: {
          'content-type': 'application/json'
        },
        mode: 'cors',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(getAccessTokenBody)
      })

      const responseData = await response.json()
      const fetchError = getIsError(responseData)
      if (fetchError) {
        throw new Error(fetchError)
      }
      if (responseData.access_token) {
        return ({ accessToken: responseData.access_token, tokenType: responseData.token_type })
      }
    }, {
      enabled: Boolean(productId)
    })

  const reviews = useQuery(
    ['useYotpoReviews', productId], async () => {
      const response = await fetch(`https://api.yotpo.com/v1/widget/${YOTPO_KEY}/products/${productId}/reviews.json`, {
        ...options,
        mode: 'cors',
        referrerPolicy: 'no-referrer'
      })

      const responseData = await response.json()
      const fetchError = getIsError(responseData)
      if (fetchError) {
        throw new Error(fetchError)
      }
      if (responseData.status?.code === 200 && responseData.response?.reviews) {
        return responseData.response.reviews
      }
    }, {
      enabled: Boolean(productId)
    })

  return {
    token,
    reviews
  }
}
